<template>
  <div
    class="relative time-limit-content"
  >
    <aha-input
      type="number"
      v-model="timeToAnswer"
      @input="updateTimeLimitSetting"
      :error="errorTimeLimitVisible"
    />
    <div class="unit-text">
      {{ $i18nPresenter.t('seconds') }}
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import debounce from 'debounce'
import Socket from '@/socket'
import SlideApi from '@/api/slide'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import EventBus from '@/eventBus'

export default {
  data() {
    return {
      timeToAnswer: null,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      currentUser: (state) => state.currentUser,
      presentation: (state) => state.presentation,
      errorTimeLimitVisible() {
        return !this.timeToAnswer
        || this.timeToAnswer < 5
        || this.timeToAnswer > 1200
      },
    }),
  },
  mounted() {
    this.timeToAnswer = this.slideActive.timeToAnswer
    EventBus.$on('slide-update-timelimit', () => {
      this.timeToAnswer = this.slideActive.timeToAnswer
    })
  },
  destroyed() {
    this.timeToAnswer = null
    EventBus.$off('slide-update-timelimit')
  },
  methods: {
    ...mapActions(['setSyncLoadingAction', 'updateSlideActiveAction']),

    async updateTimeLimitSetting() {
      try {
        if (!this.timeToAnswer || this.timeToAnswer < 5) return
        const timeToAnswerNum = parseInt(this.timeToAnswer, 10)
        if (timeToAnswerNum > 1200) {
          this.timeToAnswer = 1200
        }
        this.updateSlideActiveAction({
          timeToAnswer: this.timeToAnswer,
        })
        this.setSyncLoadingAction(1)
        await this.callUpdateSlideApi(this.timeToAnswer)
        utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Right column > Edit setting > Time limit',
          `Presenter edit time limit: ${this.timeToAnswer}`,
        )
        this.setSyncLoadingAction(2)
      } catch {
        this.setSyncLoadingAction(3)
      }
    },
    callUpdateSlideApi: debounce(async function debounceCallApi(timeToAnswer) {
      await SlideApi.updateSlideById(this.slideActive.id, {
        accessCode: this.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
        timeToAnswer,
      })
    }, 300),
    // onKeyUp() {
    //   const timeToAnswerNum = parseInt(this.timeToAnswer, 10)

    //   if (timeToAnswerNum > 1200) {
    //     this.timeToAnswer = 1200
    //   }
    // },
  },
}
</script>

<style lang="scss" scoped>
.time-limit-content {
  & ::v-deep .aha-input {
    width: 135px;
    padding-right: 70px;
  }
  .unit-text {
    @apply absolute top-2.5 right-2 text-base-70;
  }
}
</style>
